import React from "react";
import Modal from "../common/Modal";

const ErrorPopUp = ({ onClose, open, data }) => {
  return (
    <Modal
      onClose={onClose}
      open={open}
      mxWidth={"max-w-[600px]"}
      title={"Upload Error"}
    >
      <div className=" overscroll-x-none max-h-[calc(70vh-32px)] overflow-y-scroll ">
        <div className=" flex flex-col gap-12">
          <div>
            <div className=" flex flex-col gap-4">
              <pre className="text-[10px] text-wrap">{data}</pre>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorPopUp;